import React from 'react';
import HdIcon, { HevoIconProps } from '../../../media/components/icon/HdIcon';
import styles from './FilterIcon.module.scss';

export interface FilterIconProps {
  active?: boolean;
}

export default function FilterIcon({
  active,
  className,
  ...props
}: FilterIconProps & HevoIconProps) {
  return <HdIcon className={`${className} ${active ? styles.active : ''}`} {...props} />;
}
